import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './ActivateAccountPage.css';

export default function ActivateAccountPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('El enlace de acceso es inválido.');
      return;
    }
    fetch(`/api/auth/access-invite?token=${encodeURIComponent(token)}`)
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'No se pudo validar el enlace');
        setInvite(data);
      })
      .catch((requestError) => setError(requestError.message));
  }, [token]);

  const activate = async (event) => {
    event.preventDefault();
    if (password.length < 8) return setError('La contraseña debe tener al menos 8 caracteres.');
    if (password !== confirmation) return setError('Las contraseñas no coinciden.');
    setSaving(true);
    setError('');
    try {
      const response = await fetch('/api/auth/access-invite/activate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo activar el acceso');
      setDone(true);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="activation-page">
      <section className="activation-card">
        <p className="activation-brand">LANG</p>
        {done ? (
          <>
            <h1>Acceso activado</h1>
            <p>Tu contraseña quedó definida. Ya podés ingresar al sistema.</p>
            <Link className="btn btn-primary activation-submit" to="/login">Ir a iniciar sesión</Link>
          </>
        ) : error && !invite ? (
          <>
            <h1>Enlace no disponible</h1>
            <p className="activation-error">{error}</p>
            <p>Pedí a Administración que te envíe una nueva invitación.</p>
          </>
        ) : !invite ? (
          <p className="activation-muted">Validando acceso…</p>
        ) : (
          <>
            <h1>Definí tu contraseña</h1>
            <p>Hola, <strong>{invite.name || invite.email}</strong>. Este acceso quedará asociado a <strong>{invite.email}</strong>.</p>
            <form onSubmit={activate} className="activation-form">
              <label>
                Contraseña nueva
                <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" autoFocus />
              </label>
              <label>
                Repetir contraseña
                <input type="password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="new-password" />
              </label>
              {error && <p className="activation-error">{error}</p>}
              <button className="btn btn-primary activation-submit" type="submit" disabled={saving}>
                {saving ? 'Activando…' : 'Activar acceso'}
              </button>
            </form>
          </>
        )}
      </section>
    </main>
  );
}
